import React, { useContext, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import PageHeader from "../../../components/PageHeader";
import SidebarContext from "../../../context/SidebarContext";
import SimpleBar from "simplebar-react";
import AllUsers from "./AllUsers";
import PackagesUserwise from "./PackagesUserwise";
import { useDispatch, useSelector } from "react-redux";
import { PackagesTracking } from "../../../components/PackageTracking";
import OrderChats from "../../../components/common/orderChat/OrderChats";
import {
  setActiveComponent,
  setPackages,
  setRequests,
  setSelectedPackage,
  setSelectedRequest,
  setActiveItem,
} from "../../../store/commonSlice";
import { usePackagesFilters } from "./hooks/usePackagesFilters";
import { usePackagesData } from "./hooks/usePackagesData";

function Packages() {
  const dispatch = useDispatch();
  const { selectedPackage: packageActiveData, packages, activeComponent } =
    useSelector((state) => state.common);
  const { open } = useContext(SidebarContext);

  // Use custom hooks for filters and data
  const { selectedFilters, filterOptions, changeFilterHandler } =
    usePackagesFilters();
  const isLoadingPackages = usePackagesData(selectedFilters);

  // Handlers
  const userClickHandler = async (item) => {
    dispatch(setActiveComponent("Actions"));
    dispatch(setSelectedRequest(item));
    dispatch(setSelectedPackage(null));
    dispatch(setActiveItem(null));
  };

  const packageClickHandler = async (item) => {
    dispatch(setActiveComponent("Actions"));
    dispatch(setSelectedPackage(item));
    dispatch(setActiveItem(null));
  };

  const chatClickHandler = async (e, id, item) => {
    e.stopPropagation();
    dispatch(setActiveComponent("Chats"));
    dispatch(setSelectedPackage(item));
  };

  const closeHistoryHandler = () => {
    dispatch(setActiveComponent("Actions"));
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(setSelectedPackage(null));
      dispatch(setSelectedRequest(null));
      dispatch(setRequests([]));
      dispatch(setPackages([]));
    };
  }, [dispatch]);

  const steps = [
    {
      label: "Arrived",
      date: packageActiveData?.arrivedAt
        ? new Date(
          packageActiveData?.arrivedAt?.seconds * 1000
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        : "-",
    },
    { label: "Packaging", date: "-" },
    { label: "Delivery", date: "-" },
    { label: "Done", date: "-" },
  ];

  const activeStep = packageActiveData?.packageStatus === "RECEIVED_AT_WAREHOUSE" ? 2 : 1;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <PageHeader
        pageTitle={"Packages"}
        selectedFilters={selectedFilters}
        filterOptions={filterOptions}
        changeFilterHandler={changeFilterHandler}
      />
      <Box
        sx={{
          flex: 1,
          backgroundColor: "white",
          borderTop: "1px solid #E5E5E8",
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{
            width: open === false ? "calc(97vw - 80px)" : "calc(97vw - 240px)",
          }}
        >
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <AllUsers
              userClickHandler={userClickHandler}
              selectedFilters={selectedFilters}
              loading={isLoadingPackages}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ borderLeft: "1px solid #E5E5E8" }}
          >
            <PackagesUserwise
              selectedFilters={selectedFilters}
              packageClickHandler={packageClickHandler}
              chatClickHandler={chatClickHandler}
              // userActiveData={userActiveData}
              packageActiveData={packageActiveData}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{
              borderLeft: "1px solid #E5E5E8",
              height: "86vh",
            }}
          >
            <SimpleBar
              forceVisible="y"
              autoHide={true}
              style={{ maxHeight: "86vh" }}
              className="custom-scrollbar"
            >
              {activeComponent === "Chats" && (
                <OrderChats
                  closeHistory={closeHistoryHandler}
                />
              )}
              {activeComponent === "Actions" && (
                <PackagesTracking
                  steps={steps}
                  activeStep={activeStep}
                />
              )}
            </SimpleBar>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default Packages;
